import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { TeaserBoxLink } from '../../../shared/teaser-box/teaser-box.component'
import { Image } from '../../../types'
import { TeaserBoxMediaData } from '../teaser-boxes-media.component'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TeaserBoxDocumentConverter extends CmsConverterService<TeaserBoxDocumentData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_title_text?.value
    const altText = formData?.st_alt_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    const link = formData.st_document_link ?? defaultLinkData
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      teaserBoxData: {
        link: {
          ...link,
          highlight: formData?.st_document_link?.value?.formData?.highlight?.value?.identifier === 'true' ?? false,
          assetType: link.assetType || (link.mime === 'application/pdf' ? 'PDF' : ''),
        } as TeaserBoxLink,
        description: formData.st_description ?? defaultTextInput,
        headline: formData.st_headline ?? defaultTextInput,
        label: formData.st_label ?? defaultTextInput,
        sticker: formData?.st_highlighting?.value?.identifier ?? '',
        backgroundColor: 'bg-' + (formData?.st_backgroundcolor?.value?.identifier ?? 'grey'),
        promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? false
      },
    }
  }
}

export const TEASER_BOX_DOCUMENT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBoxDocumentData>>(
  'TeaserBoxDocumentConverter')

export interface TeaserBoxDocumentData extends TeaserBoxMediaData {
  image: Image;
}

